import { type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      useErrorBoundary: true,
    },
    mutations: {},
  },
});

const QueryProvider = (props: { children: ReactNode }) => (
  <QueryClientProvider client={queryClient} {...props} />
);

export { QueryProvider, queryClient };
